import React from 'react'
import { Box, LinearProgress, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import { DashboardTablePaper } from 'components'

import useStyles from './styles'

const TrainedUsersByDepartment = ({ trainings, ...rest }) => {
  const classes = useStyles()

  return (
    <DashboardTablePaper
      title="Departamentos com maior número de usuários que concluíram o treinamento"
      tableType="training"
      className={classes.root}
      {...rest}
    >
      {trainings?.map((department) => (
        <Box px={2} key={department.id}>
          <Box className={classes.lineTitle}>
            <Typography className={classes.rowName}>
              {department.name}
            </Typography>
            <Typography className={classes.rowValue}>
              {department.certifiedPeople}
            </Typography>
          </Box>
          <Box>
            <LinearProgress
              className={classes.lineBar}
              variant="determinate"
              value={(department.certifiedPeople / department.totalUsers) * 100}
            />
          </Box>
        </Box>
      ))}
    </DashboardTablePaper>
  )
}

TrainedUsersByDepartment.propTypes = {
  trainings: PropTypes.array.isRequired,
}

export default TrainedUsersByDepartment
